import { SelectAllConfigInterface } from '../models';

export const SelectAllDefaultsConfig: SelectAllConfigInterface = {
    showSelectAll: false,
    minInputValue: 1,
    maxListLength: undefined,
}
